import React from 'react';
import cx from 'classnames';
import { Button, Text, Heading, Box, TextButton } from '@wix/design-system';
import styles from './ArenaOnboardingPage.scss';
import { OneTapDisclaimer } from '../../welcomePage/OneTapDisclaimer';

const ArenaOnboardingPage = props => {
  const { t, shouldShowOneTapDisclaimer, onGoToOnArena, onGoToOnBoarding, onGoToLogin, loginInSplitscreen } = props;

  const getDivider = () => {
    return (
      <div className={styles.divider}>
        <div className={styles.line} />
        <div className={styles.or}>{t('LOGO_ON_BOARDING_SPLIT_HIRE_OR')}</div>
        <div className={styles.line} />
      </div>
    );
  };

  const getContainer = (titleText, descriptionText, buttonText, onClick, dataHook, withLogin) => {
    return (
      <div className={styles.halfPageContainer}>
        <div className={styles.title}>
          <Heading size="extraLarge">
            <span className={styles.titleFont}>{titleText}</span>
          </Heading>
        </div>
        <div className={styles.subtitle}>
          <Text size="medium" weight="normal">
            <span className={styles.subtitleFont}>{descriptionText}</span>
          </Text>
        </div>
        <div className={styles.action}>
          <Button dataHook={dataHook} className={styles.link} size="large" onClick={onClick}>
            {buttonText}
          </Button>
        </div>
        {withLogin ? (
          <Box marginTop={'24px'} gap={'6px'} align="center" textAlign="center">
            <Text size="medium" weight="normal">
              {t('LOGO_ON_BOARDING_SPLIT_LOGIN_DESCRIPTION')}
              <Box inline paddingLeft={'6px'}>
                <TextButton size="medium" weight="normal" onClick={onGoToLogin}>
                  {t('LOGO_ON_BOARDING_SPLIT_LOGIN')}
                </TextButton>
              </Box>
            </Text>
          </Box>
        ) : null}
      </div>
    );
  };

  const getDesignerContainer = () => {
    return getContainer(
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_TITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_SUBTITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_DESIGNER_CTA'),
      onGoToOnArena,
      'designer-btn'
    );
  };

  const getLogoContainer = () => {
    return getContainer(
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_TITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_SUBTITLE'),
      t('LOGO_ON_BOARDING_SPLIT_HIRE_SELF_CTA'),
      onGoToOnBoarding,
      'logo-btn',
      loginInSplitscreen
    );
  };

  const sides = [getLogoContainer(), getDesignerContainer()];

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <Text size="medium" weight="normal">
            {t('LOGO_ON_BOARDING_SPLIT_HIRE_HEADER')}
          </Text>
        </div>
      </div>

      <div className={styles.container}>
        <div className={cx(styles.split)}>
          {sides[0]}
          {getDivider()}
          {sides[1]}
        </div>
      </div>
      {shouldShowOneTapDisclaimer && <OneTapDisclaimer {...props} />}
    </div>
  );
};

export default ArenaOnboardingPage;
